/**
 * The client's copy of the one test-state rule. The server's
 * `src/server/services/testState.ts` is the source; this file only carries the
 * labels and the reading, so every screen says the same words. A server test
 * (`testState.test.ts`) reads this file and fails the build if the two drift.
 *
 *   pass            Pass             a finished test
 *   fail            Fail             a finished test
 *   cant_test       Couldn't test    the tech couldn't get to the device; readings kept
 *   incomplete      Not finished     started, not finished
 *   unknown         Result not known an old record nobody has read; not a pass, not a fail
 */

export const TEST_STATES = ["pass", "fail", "cant_test", "incomplete", "unknown"] as const;
export type TestState = (typeof TEST_STATES)[number];

export const TEST_STATE_LABELS: Record<TestState, string> = {
    pass: "Pass",
    fail: "Fail",
    cant_test: "Couldn't test",
    incomplete: "Not finished",
    unknown: "Result not known",
};

export function testState(overallResult: string | null | undefined): TestState | null {
    if (overallResult === null || overallResult === undefined) return null;
    const v = String(overallResult).trim().toLowerCase();
    if (v === "") return null;
    if (v === "pass" || v === "fail" || v === "cant_test" || v === "incomplete") return v;
    return "unknown";
}

/** A pass or a fail: the only results that count as tested. */
export function isFinishedTest(overallResult: string | null | undefined): boolean {
    const s = testState(overallResult);
    return s === "pass" || s === "fail";
}

/** Badge look for a result: green pass, red fail, grey for everything else. */
export function testStateTone(overallResult: string | null | undefined): "pass" | "fail" | "neutral" {
    const s = testState(overallResult);
    if (s === "pass") return "pass";
    if (s === "fail") return "fail";
    return "neutral";
}

export function testStateLabel(overallResult: string | null | undefined): string {
    const s = testState(overallResult);
    return s ? TEST_STATE_LABELS[s] : "";
}
